/*
  article-v2.js
  Progressive enhancement for the clean article template. Loaded with defer, so it
  runs after the document is parsed. Everything degrades gracefully: with JS off the
  article is fully readable, only the auto table of contents and active-link highlight
  are skipped. No dependencies. ASCII only.
*/
(function () {
  "use strict";

  var root = document.querySelector(".article-v2");
  if (!root) return;

  var body = root.querySelector("[data-article-body]");

  /* ---- 1. Tag the lead answer paragraph (engine renders the direct answer as a
     single bold paragraph at the very top). Purely additive styling hook. ---- */
  function highlightAnswer() {
    if (!body || root.getAttribute("data-highlight-answer") !== "true") return;
    var first = null;
    var i;
    for (i = 0; i < body.children.length; i += 1) {
      var el = body.children[i];
      if (el.tagName === "P") { first = el; break; }
      if (el.tagName === "H1" || el.tagName === "H2" || el.tagName === "H3") return;
    }
    if (!first) return;
    var text = (first.textContent || "").trim();
    if (text.length < 20 || text.length > 400) return;
    var strong = first.querySelector("strong, b");
    if (!strong) return;
    // Only treat it as the answer when the bold text is essentially the whole paragraph.
    if ((strong.textContent || "").trim().length < text.length * 0.6) return;
    first.classList.add("article-v2__answer");
  }

  /* ---- 2. Slug helper with de-duplication so anchors are always unique. ---- */
  var usedIds = {};
  function slugify(value) {
    var base = (value || "")
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
    if (!base) base = "section";
    var id = base;
    var n = 2;
    while (usedIds[id] || document.getElementById(id)) {
      id = base + "-" + n;
      n += 1;
    }
    usedIds[id] = true;
    return id;
  }

  /* ---- 3. Build the table of contents from the article headings. Generates an id
     on any heading that lacks one so this works for the 57 legacy articles too. ---- */
  function buildToc() {
    var toc = root.querySelector("[data-toc]");
    var list = root.querySelector("[data-toc-list]");
    if (!toc || !list || !body) return null;

    var includeH3 = toc.getAttribute("data-toc-h3") === "true";
    var selector = includeH3 ? "h2, h3" : "h2";
    var headings = body.querySelectorAll(selector);
    if (!headings.length) return null;

    var frag = document.createDocumentFragment();
    var linked = [];

    headings.forEach(function (heading) {
      var label = (heading.textContent || "").trim();
      if (!label) return;
      if (!heading.id) {
        heading.id = slugify(label);
      } else {
        usedIds[heading.id] = true;
      }
      var li = document.createElement("li");
      if (heading.tagName === "H3") li.className = "is-sub";
      var a = document.createElement("a");
      a.href = "#" + heading.id;
      a.textContent = label;
      li.appendChild(a);
      frag.appendChild(li);
      linked.push({ id: heading.id, link: a, heading: heading });
    });

    if (!linked.length) return null;
    list.appendChild(frag);
    toc.removeAttribute("hidden");
    return linked;
  }

  /* ---- 4. Open the TOC by default on wide screens (collapsed on mobile). ---- */
  function syncTocOpenState() {
    var details = root.querySelector(".article-v2__toc-details");
    if (!details) return;
    var wide = window.matchMedia("(min-width: 1100px)").matches;
    details.open = wide;
  }

  /* ---- 5. Highlight the TOC entry for the section currently in view. ---- */
  function trackActive(linked) {
    if (!linked || !("IntersectionObserver" in window)) return;
    var byId = {};
    linked.forEach(function (item) { byId[item.id] = item.link; });
    var current = null;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var link = byId[entry.target.id];
          if (!link || link === current) return;
          if (current) current.classList.remove("is-active");
          link.classList.add("is-active");
          current = link;
        });
      },
      { rootMargin: "-90px 0px -70% 0px", threshold: 0 }
    );

    linked.forEach(function (item) { observer.observe(item.heading); });
  }

  highlightAnswer();
  var linked = buildToc();
  syncTocOpenState();
  trackActive(linked);

  var resizeTimer;
  window.addEventListener("resize", function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(syncTocOpenState, 150);
  });
})();
